<template>
<div class="modal" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <slot/>
      </div>
      <div class="modal-footer">
        <slot name="footer"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import $ from 'jquery'
export default {
  methods: {
    showModal () {
      var target = $('#' + this.$el.id)
      if (target.length) {
        target.modal()
      }
    },
    hideModal () {
      var target = $('#' + this.$el.id)
      if (target.length) {
        target.modal('hide')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// SimpleModal.vue?2159ffe0